import { Component, OnInit } from '@angular/core';
import { FooterService } from '../../components/footer/footer.service';
import { CommonService } from '../../shared/common.service';
import { UserLayoutService } from '../../layouts/user-layout/user-layout.service';
import { StorageKey, StorageService } from '../../shared/storage.service';

@Component({
  selector: 'app-redirect-faq',
  templateUrl: './redirect-faq.component.html',
  styleUrls: ['./redirect-faq.component.css']
})
export class RedirectFaqComponent implements OnInit {
  faqs: any[] = [];
  errorMessage: string = '';

  constructor(
    private footerService: FooterService,
    public commonService: CommonService,
    public userLayoutService: UserLayoutService,
    public storageService: StorageService,
  ) { }

  ngOnInit(): void {
    
    this.footerService.hideFooter();
    
    this.fetchFaqs();
    
  }

  fetchFaqs(): void {
    
    // const userId = this.storageService.getValue(StorageKey._id);

    // if (userId) {
      // const faqsData = { userId: userId };
      

      this.userLayoutService.faqs().subscribe((response: any) => {
        if (response.code === 1) {
          
          this.faqs = response.data.map(faq => ({ ...faq, isOpen: false }));
          // console.log("faqs", this.faqs);
        } else {
          this.errorMessage = response.message;
          this.commonService.notifier.notify('error', response.message);
        }
      },
        (error) => {
          
          this.errorMessage = 'Failed to fetch profile data';
          // console.log('Profile API Error:', error);
          this.commonService.notifier.notify('error', this.errorMessage);
        });
    // } else {
    //   
    //   this.errorMessage = 'No user ID found. Please log in.';
    //   this.commonService.notifier.notify('error', this.errorMessage);
    // }
  }

  toggleContent(index: number): void {
    this.faqs[index].isOpen = !this.faqs[index].isOpen;
  }

}
